module.exports = __webpack_public_path__ + "static/media/gmap-milkindo.7596f215.png";